export const parentDashboardEn = {
  // Sections
  home: 'Home',
  myGrades: 'My Grades',
  quranProgress: 'Quran Progress',
  myMessages: 'My Messages',
  logout: 'Logout',
  
  // Welcome
  welcome: 'Welcome',
  parentOf: 'Parent of:',
  noLinkedStudents: 'No linked students',
  
  // Stats
  averageHifz: 'Average Memorization',
  noSessionsToday: 'No session',
  averageGrades: 'Average Grades',
  subjectsCount: 'Number of Subjects',
  receivedMessages: 'Received Messages',
  sentMessages: 'Sent Messages',
  noReceivedMessages: 'No received messages',
  noSentMessages: 'No sent messages',
  hizbUnit: 'Hizb',
  
  // Messages
  recentMessages: 'Recent Messages',
  noMessages: 'No messages',
  from: 'From:',
  to: 'To:',
  refresh: 'Refresh',
  sendMessage: 'Send Message',
  selectStudent: 'Select Student',
  selectRecipient: 'Select Recipient',
  recipientTeacher: 'Teacher',
  recipientAdmin: 'Admin',
  administration: 'Administration',
  teachers: 'Teachers',
  messageSubject: 'Message Subject',
  messagePlaceholder: 'Write your message here...',
  sendButton: 'Send',
  messageSent: 'Message sent successfully',
  messageError: 'Error sending message',
  
  // Message priorities
  priorityNormal: 'Normal',
  priorityHigh: 'High',
  priorityUrgent: 'Urgent',
  
  // Report types
  reportTypeAssignment: 'Homework',
  reportTypeProgress: 'Progress Report',
  reportTypeAchievement: 'Outstanding Achievement',
  reportTypeConcern: 'Important Note',
  
  // Quran progress
  lastSession: 'Last Session',
  newMemorization: 'New Memorization',
  review: 'Review',
  assignmentForNextSession: 'Assignment for Next Session',
  note: 'Note',
  hizbMemorized: 'Hizb Memorized',
  progressLevel: 'Progress Level',
  percentageOfQuran: 'of Quran',
  
  // Progress levels
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
  veryAdvanced: 'Very Advanced',
  
  // Grades
  linkedStudentsGrades: 'Linked Students Grades',
  student: 'Student',
  studentLabel: 'Student(s)',
  subject: 'Subject',
  grade: 'Grade',
  date: 'Date',
  comment: 'Comment',
  noGrades: 'No grades available',
  
  // Common
  update: 'Update',
  loading: 'Loading...',
  error: 'Error',
  retry: 'Retry',
  dateUnknown: 'Not specified',
  cancel: 'Cancel',
  optional: 'Optional',
  
  // Message
  message: 'Message',
  
  // Send message form
  selectAdminOrTeachers: 'Please select Administration or Teachers or both',
  selectStudentForTeachers: 'Please select a student to send the message to teachers',
  noTeachersForStudent: 'No teachers linked to this student. Please contact the administration.',
  messageWillBeSentToAdmins: 'The message will be sent to all administrators',
  messageWillBeSentToAdminsOnly: 'The message will be sent to all administrators only',
  messageWillBeSentToAdminsAndTeachers: 'The message will be sent to all administrators and the selected student\'s teachers',
  messageWillBeSentToTeachersOnly: 'The message will be sent to the selected student\'s teachers only',
  selectStudentForTeachersMessage: 'Please select a student to send the message to their teachers',
  messageWillBeSentToAdminsSelectStudent: 'The message will be sent to all administrators. Please select a student to send the message to their teachers.',
  
  // Password change
  changePassword: 'Change Password',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',
  enterOldPassword: 'Enter old password',
  enterNewPassword: 'Enter new password',
  confirmNewPassword: 'Confirm new password',
  passwordChangedSuccess: 'Password changed successfully',
  errorChangingPassword: 'Error changing password',
  passwordTooShort: 'Password must be at least 6 characters',
  passwordMismatch: 'Passwords do not match',
  fillAllFields: 'Please fill all fields',
  changing: 'Changing...',

  // Branding & sender types
  associationName: 'Al-Falah Association',
  parentBoardSubtitle: 'Parent Dashboard',
  senderTeacher: 'Teacher',
  senderAdmin: 'Admin',
  senderParent: 'Parent',
  notSpecified: 'Not specified',
};

